import { useEffect } from "react";
import { fetchMaintenanceStatus } from "../../services/systemSettingsService";

const MaintenanceGuard = () => {
  useEffect(() => {
    (async () => {
      try {
        const { maintenanceMode } = await fetchMaintenanceStatus();
        const path = window.location?.pathname || "";
        const onMaintenance = path.startsWith("/maintenance");
        const isAdminRoute = path.startsWith("/admin");
        // Only impact the frontend; allow /admin during maintenance
        if (maintenanceMode && !onMaintenance && !isAdminRoute) {
          window.location.replace("/maintenance");
        }
      } catch {}
    })();
    // initial load only
     
  }, []);

  return null;
};

export default MaintenanceGuard;
